import React from 'react';
import { Instagram, Facebook, Mail, HelpCircle, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import PageLayout from '@/components/layout/PageLayout';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const AboutPage: React.FC = () => {
  return (
    <PageLayout 
      title="About forkast" 
      description="Learn more about the forkast app"
    >
      <div className="space-y-6 max-w-2xl mx-auto pb-8">
        {/* App Info & Legal */}
        <Card>
          <CardHeader className="pb-4">
            <CardTitle className="flex items-center gap-2 text-lg">
              <Shield className="h-5 w-5" />
              App Information
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-sm text-muted-foreground">
              <p>By using this app, you agree to our{' '}
                <Link 
                  to="/terms"
                  className="text-primary hover:underline font-medium"
                >
                  Terms of Service
                </Link>
                {' '}and{' '}
                <Link 
                  to="/privacy"
                  className="text-primary hover:underline font-medium"
                >
                  Privacy Policy
                </Link>
                {' '}(v1.1, September 4, 2025)
              </p>
            </div>
          </CardContent>
        </Card>

        {/* Support */}
        <Card>
          <CardHeader className="pb-4">
            <CardTitle className="flex items-center gap-2 text-lg">
              <HelpCircle className="h-5 w-5" />
              Support
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <Link
              to="/meal-planning-app-faqs"
              className="w-full flex items-center justify-start gap-2 text-primary hover:text-primary/80 transition-colors py-2 px-4 rounded-lg hover:bg-primary/5"
            >
              <span className="font-medium">Frequently Asked Questions</span>
            </Link>
            <div className="flex items-center gap-4">
              <Link
                to="/how-forkast-meal-planning-works"
                className="text-primary hover:text-primary/80 transition-colors py-2 px-4 rounded-lg hover:bg-primary/5"
              >
                <span className="font-medium">How It Works</span>
              </Link>
              <Link
                to="/meal-planning-tips"
                className="text-primary hover:text-primary/80 transition-colors py-2 px-4 rounded-lg hover:bg-primary/5"
              >
                <span className="font-medium">Tips</span>
              </Link>
            </div>
          </CardContent>
        </Card>

        {/* Social Media */}
        <Card>
          <CardHeader className="pb-4">
            <CardTitle className="text-lg">Follow Us</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-col sm:flex-row gap-4">
              <a 
                href="https://www.instagram.com/forkast.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-muted-foreground hover:text-terracotta transition-colors py-2 px-3 rounded-lg hover:bg-terracotta/5"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="h-5 w-5" />
                <span className="font-medium">Instagram</span>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61577596438192"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-muted-foreground hover:text-terracotta transition-colors py-2 px-3 rounded-lg hover:bg-terracotta/5"
                aria-label="Follow us on Facebook"
              >
                <Facebook className="h-5 w-5" />
                <span className="font-medium">Facebook</span>
              </a>
            </div>
          </CardContent>
        </Card>

        {/* Contact */}
        <Card>
          <CardHeader className="pb-4">
            <CardTitle className="flex items-center gap-2 text-lg">
              <Mail className="h-5 w-5" />
              Contact Us
            </CardTitle>
          </CardHeader>
          <CardContent>
            <a 
              href="mailto:forkast.in.app@gmail.com"
              className="flex items-center gap-3 text-primary hover:text-primary/80 transition-colors py-2 px-3 rounded-lg hover:bg-primary/5 font-medium"
            >
              <span>forkast.in.app@gmail.com</span>
            </a>
          </CardContent>
        </Card>
      </div>
    </PageLayout>
  );
};

export default AboutPage;